export default "__VITE_ASSET__RSejW6Gi__"